import type {
  LC_SystemPageItem,
  LC_RoleInterfaceSectionItem,
  SystemPage,
  RoleSection,
} from './rolePermissions.types';


export const mapSystemPage = (item: LC_SystemPageItem): SystemPage => ({
  id: item.id,
  name: item.name ?? '',
  description: item.description,
  url: item.url,
});

export const mapRoleSection = (item: LC_RoleInterfaceSectionItem): RoleSection => ({
  id: item.id,
  name: item.name ?? '',
  description: item.description ?? '',
  code: item.code ?? '',
  read: item.read,
  create: item.create,
  write: item.write,
  delete: item.delete,
});
